/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const LOCATION_TZ = Object.freeze({
    5121212: 'America/New_York',
    5131313: 'America/New_York',
    5141414: 'America/New_York',
    5151515: 'America/New_York',
    5161616: 'America/New_York',
    5171717: 'America/Chicago',
    5181818: 'America/New_York',
    5191919: 'America/New_York',
    5202020: 'America/Chicago',
    5212121: 'America/New_York',
    5222222: 'America/New_York',
    5232323: 'America/New_York',
    5242424: 'America/New_York',
    5252525: 'America/New_York',
    5262626: 'America/Denver',
    5272727: 'America/New_York',
    5282828: 'America/Chicago',
    5292929: 'America/Los_Angeles',
    5303030: 'America/Chicago',
    5313131: 'America/New_York',
    5323232: 'America/New_York',
    5333333: 'America/New_York',
    5343434: 'America/Chicago',
    5353535: 'America/Chicago',
    5363636: 'America/Chicago',
    5373737: 'America/New_York',
    5383838: 'America/New_York',
    5393939: 'America/New_York',
    5404040: 'America/New_York',
});

export const BOOKING_HOUR_CUTOFF = Object.freeze({
    5121212: '15:00',
    5131313: '15:00',
    5141414: '15:00',
    5151515: '15:00',
    5161616: '15:00',
    5171717: '15:00',
    5181818: '15:00',
    5191919: '15:00',
    5202020: '15:00',
    5212121: '15:00',
    5222222: '15:00',
    5232323: '15:00',
    5242424: '15:00',
    5252525: '15:00',
    5262626: '15:00',
    5272727: '15:00',
    5282828: '15:00',
    5292929: '15:00',
    5303030: '15:00',
    5313131: '15:00',
    5323232: '15:00',
    5333333: '15:00',
    5343434: '15:00',
    5353535: '15:00',
    5363636: '15:00',
    5373737: '15:00',
    5383838: '15:00',
    5393939: '15:00',
    5404040: '15:00',
});

// Permit Types
export const permitTypes = Object.freeze({
    MUZZLE_LOADER: 'muzzleloader',
    MUZZLE_LOADER_LIMITED: 'muzzleloader-limited',
    MUZZLE_LOADER_OPEN: 'muzzleloader-open',
    MUZZLE_LOADER_OPEN_EARLY: 'muzzleloader-open-early-season',
    MUZZLE_LOADER_OPEN_LATE: 'muzzleloader-open-late-season',
    SHOTGUN_LIMITED: 'shotgun-limited',
    SHOTGUN_OPEN: 'shotgun-open',
    SHOTGUN_OPEN_EARLY: 'shotgun-open-early-season',
    SHOTGUN_OPEN_LATE: 'shotgun-open-late-season',
    YOUTH_HUNT: 'youth-hunt-open',
    DISABLED_HUNT: 'disabled',
    ARCHERY: 'archery',
    TURKEY_HUNT: 'turkey-hunt',
    WATERFOWL_HUNT: 'waterfowl-hunt',
    ALLATOONA_HUNT: 'allatoona-hunt',
    LAKE_GEORGETOWN_HUNT: 'georgetown-lake-hunt-lottery',
    PRIMITIVE: 'primitive',
    SPORTSMANS_PACKAGE: 'sportsmans-package',
    GENERAL_FIREARMS: 'general-firearms',
    SPECIAL_ANTLERLESS: 'special-antlerless',
    BELTON_LAKE_HUNT: 'belton-lake-hunt-lottery',
    LAKE_LANIER_HUNT: 'lake-lanier-hunt',
    CAROLINA_SANDHILLS_HUNT: 'carolina-sandhills-hunt-lottery',
    WALTER_F_GEORGE_LAKE: 'walter-f-george-lake-hunt',
    TENNESSEE_TOMBIGBEE_WATERWAY_HUNT: 'tennessee-tombigbee-waterway-hunt',
    PIEDMONT_NWR_PRIMITIVE_HUNT: 'piedmont-nwr-primitive-hunt',
    PIEDMONT_NWR_FIREARMS_HUNT_1: 'piedmont-nwr-firearms-hunt-1',
    PIEDMONT_NWR_FIREARMS_HUNT_2: 'piedmont-nwr-firearms-hunt-2',
    DEER_HUNT_LOTTERY: 'deer-hunt-lottery',
    LAS_VEGAS_NWR_GOOSE_HUNT: 'las-vegas-nwr-goose-hunt',
    PIEDMONT_NWR_TURKEY_HUNT_1: 'piedmont-nwr-turkey-hunt-1',
    PIEDMONT_NWR_TURKEY_HUNT_2: 'piedmont-nwr-turkey-hunt-2',
    PIEDMONT_NWR_TURKEY_HUNT_3: 'piedmont-nwr-turkey-hunt-3',
    SOMERVILLE_LAKE_HUNT: 'somerville-lake-hunt-lottery',
    HAVASU_WATERFOWL_HUNT: 'havasu-nwr-waterfowl-hunt',
    WHITNEY_AQUILLA_LAKES_HUNT: 'whitney-and-aquilla-lakes-hunt',
    BOND_SWAMP_DEER_HUNT_1: 'bond-swamp-deer-hunt-1',
    BOND_SWAMP_DEER_HUNT_2: 'bond-swamp-deer-hunt-2',
    BOND_SWAMP_TURKEY_HUNT_1: 'bond-swamp-turkey-hunt-1',
    BOND_SWAMP_TURKEY_HUNT_2: 'bond-swamp-turkey-hunt-2',
    BOND_SWAMP_WATERFOWL_HUNT_1: 'bond-swamp-waterfowl-hunt-1',
    BOND_SWAMP_WATERFOWL_HUNT_2: 'bond-swamp-waterfowl-hunt-2',
    BOND_SWAMP_WATERFOWL_HUNT_3: 'bond-swamp-waterfowl-hunt-3',
    BOND_SWAMP_WATERFOWL_HUNT_4: 'bond-swamp-waterfowl-hunt-4',
    WACO_LAKE_HUNT: 'waco-lake-hunt',
    LAKE_GEORGETOWN_WATERFOWL_HUNT: 'georgetown-waterfowl-hunt-lottery',
    LAKE_GEORGETOWN_OTHER_HUNT: 'georgetown-other-hunt-lottery',
    OKEFENOKEE_SUWANNEE_CANAL_HUNT_1: 'okefenokee-suwannee-hunt-1',
    OKEFENOKEE_SUWANNEE_CANAL_HUNT_2: 'okefenokee-suwannee-hunt-2',
    MATTAMUSKEET_NWR_WATERFOWL_HUNT: 'mattamuskeet-nwr-waterfowl-hunt-lottery',
    MATTAMUSKEET_DISABLED_WATERFOWL_HUNT: 'mattamuskeet-disabled-waterfowl-hunt-lottery',
    MATTAMUSKEET_YOUTH_WATERFOWL_HUNT_1: 'mattamuskeet-youth-waterfowl-hunt-1',
    MATTAMUSKEET_YOUTH_WATERFOWL_HUNT_2: 'mattamuskeet-youth-waterfowl-hunt-2',
});

// Lottery Reservation Fee Map
export const RESERVATION_FEE_BY_PERMIT_TYPE = Object.freeze({
    5141414: 6,
    5171717: 10,
    5181818: 6,
    5191919: 6,
    5202020: 15,
    5222222: 10,
    5282828: 10,
    5353535: 10,
    5363636: 10,
    5383838: 6,
    5393939: 6,
});
